// extracted by mini-css-extract-plugin
module.exports = {"Headers":"Headers__2UZaZ"};